import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useTranslate } from "react-polyglot";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { useCourseProvider } from "../../../Providers/Data/CourseProvider.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";
import BranchCardHorizontal from "./components/BranchCardHorizontal.jsx";
import BranchCardVertical from "./components/BranchCardVertical.jsx";

const useStyles = makeStyles((theme) => ({
  branchesName: {
    color: "#1B1C1C",
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.25,
  },
  branchMainBox: {
    maxWidth: 532,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 20,
  },
  branchMainBoxTile: {
    maxWidth: "calc(100% + 18px)",
    display: "flex",
    flexWrap: "wrap",
    marginLeft: -18,
    marginRight: 0,
    justifyContent: "start",
    [theme.breakpoints.down("md")]: {
      maxWidth: "calc(100% + 40px)",
      marginLeft: -40,
    },
  },
}));

/** */
const BranchList = () => {
  const classes = useStyles();
  const t = useTranslate();
  const { branchesForLevel } = useCourseProvider();
  const { availableSubjects, subject } = useBaseData();
  const [currentSubject, setCurrentSubject] = useState(null);

  useEffect(() => {
    if (subject && availableSubjects)
      setCurrentSubject(availableSubjects.find((item) => item.id === subject.subjectId));
  }, [availableSubjects, subject]);

  return (
    <Box>
      <Typography className={classes.branchesName}>{`${t("branches")}:`}</Typography>
      <Box
        className={clsx(classes.branchMainBox, {
          [classes.branchMainBoxTile]: !currentSubject?.showBranchesAsList,
        })}
      >
        {branchesForLevel?.length > 0 &&
          branchesForLevel.map((branch, i) => (
            <React.Fragment key={branch.id}>
              {currentSubject?.showBranchesAsList ? (
                <BranchCardHorizontal branch={branch} index={i} />
              ) : (
                <BranchCardVertical branch={branch} />
              )}
            </React.Fragment>
          ))}
      </Box>
    </Box>
  );
};

export default BranchList;
